import React, { useState, useRef, useEffect } from "react";

import BcSepIcon from "../../asset/images/about/breadcrumb-separator.svg";

// Icons for advantages
import PowerIcon    from "../../asset/images/products/precicon-s/icon-power.svg";
import CheckIcon    from "../../asset/images/products/precicon-s/icon-check.svg";
import RippleIcon   from "../../asset/images/products/precicon-s/icon-ripple.svg";
import SpeedIcon    from "../../asset/images/products/precicon-s/icon-speed.svg";
import EnergyIcon   from "../../asset/images/products/precicon-s/icon-energy.svg";
import MonitorIcon  from "../../asset/images/products/precicon-s/icon-monitor.svg";
import RapperIcon   from "../../asset/images/products/precicon-s/icon-rapper.svg";
import FactoryIcon  from "../../asset/images/products/precicon-s/icon-factory.svg";
import LeafIcon     from "../../asset/images/products/precicon-s/icon-leaf.svg";

// HMI image for spec table
import HmiImg from "../../asset/images/products/precicon-s/hmi.png";

// Product image
import ProductImg from "../../asset/images/products/precicon-s/product.webp";


const ADVANTAGES = [
  { icon: PowerIcon,   text: "High-frequency IGBT-based power controller for superior ESP performance." },
  { icon: CheckIcon,   text: "3-phase input ensures stable and efficient power delivery." },
  { icon: RippleIcon,  text: "Smooth power output with reduced ripples for consistent dust separation." },
  { icon: SpeedIcon,   text: "Faster voltage regulation and precise control under fluctuating dust loads." },
  { icon: EnergyIcon,  text: "Minimizes energy losses, reduces electrical stress, and lowers maintenance costs." },
  { icon: MonitorIcon, text: "Seamless integration via CAN Bus & remote monitoring through the DCSIM Gateway." },
  { icon: RapperIcon,  text: "In-built rapping control optimizes cleaning cycles for enhanced efficiency." },
];

const END_APPLICATIONS = [
  { icon: FactoryIcon, text: "Industries: Cement, steel, power, paper & pulp, and chemicals." },
  { icon: LeafIcon,    text: "Ideal for demanding ESP operations requiring improved dust collection & environmental compliance." },
];

const SPECS = [
  { label: "Controller",                         value: "Precicon S",        isImage: false },
  { label: "HMI",                                value: HmiImg,              isImage: true  },
  { label: "No Of Controller Operated By 1 HMI", value: "30 Nos",            isImage: false },
  { label: "HMI IP Protection",                  value: "IP 54",             isImage: false },
  { label: "Operating Technology",               value: "IGBT Based",        isImage: false },
  { label: "Input Phase",                        value: "3 Phase",           isImage: false },
  { label: "Output Phase",                       value: "1 Phase (L-L)",     isImage: false },
  { label: "Line Frequency",                     value: "50/60 Hz",          isImage: false },
  { label: "Input Voltage",                      value: "380-480V (L-L)",    isImage: false },
  { label: "Output Voltage",                     value: "As Per Rated TR",   isImage: false },
  { label: "Controller Input Supply",            value: "110 VAC, -10% +10%, 50/60 Hz", isImage: false },
  { label: "No. Input Signal",                   value: "4",                 isImage: false },
  { label: "No. Output Signal",                  value: "4",                 isImage: false },
  { label: "Output Signal Protection",           value: "Galvanic Isolation", isImage: false },
  { label: "Output Resistance",                  value: "750 Ohms (Max)",    isImage: false },
  { label: "Communication Protocol",             value: "CAN Bus",           isImage: false },
  { label: "In Built No. Of Rapper Controlling", value: "4",                 isImage: false },
  { label: "Remote Monitoring",                  value: "Data Can Be Monitored On DCS With The Help Of Gateway DCSIM", isImage: false },
  { label: "Ambient Temp",                       value: "50°C",              isImage: false },
  { label: "Humidity",                           value: "95% Max, Non-Condensing", isImage: false },
  { label: "Approvals",                          value: "CE, CSA",           isImage: false },
];

const FAQS = [
  {
    q: "What makes Precicon S superior to conventional thyristor-based controllers for ESPs?",
    a: "Precicon S uses high-frequency IGBT-based power switching, offering smoother power output with reduced ripples. This ensures more consistent dust separation, faster voltage regulation, and precise control even under fluctuating dust loads, making it more efficient and reliable than traditional thyristor-based systems.",
  },
  {
    q: "How does Precicon S enhance operational efficiency and reduce costs?",
    a: "Precicon S minimizes energy losses and reduces electrical stress on ESP components, which extends equipment life and lowers maintenance costs. Its optimized cleaning cycles, facilitated by in-built rapping controls, further improve efficiency and ensure sustained performance.",
  },
  {
    q: "What integration and monitoring capabilities does Precicon S offer?",
    a: "Precicon S supports seamless integration with CAN Bus communication and remote monitoring through the DCSIM Gateway. These features enable proactive maintenance, reducing downtime and ensuring uninterrupted ESP operations.",
  },
  {
    q: "What industries can benefit from Precicon S?",
    a: "Precicon S is ideal for industries like cement, steel, power, paper & pulp, and chemicals. It is specifically designed for demanding operations where stable, efficient dust collection and environmental compliance are crucial.",
  },
  {
    q: "How does Precicon S help industries meet environmental standards?",
    a: "By delivering consistent and effective dust separation, Precicon S ensures reliable ESP performance. This helps industries comply with stringent environmental regulations while maintaining efficient and sustainable operations.",
  },
  {
    q: "What are IGBT modules used for in 2025?",
    a: "In 2025, IGBT modules are crucial for efficient power management in electric vehicles, renewable energy systems, industrial automation, and high-voltage power transmission, offering high efficiency and fast switching capabilities.",
  },
  {
    q: "Best IGBT modules for industrial power control:",
    a: "The Ador Powertron Precicon S Series is an ideal choice, designed specifically for demanding applications like electrostatic precipitators (ESPs), offering reliable, smooth power delivery and enhanced energy efficiency.",
  },
  {
    q: "What makes Ador Powertron IGBT modules unique?",
    a: "Ador Powertron's IGBT modules, such as the Precicon S Series, are designed for demanding industrial applications. They offer:",
    bullets: [
      "High reliability: Ensuring consistent performance in harsh environments",
      "Energy efficiency: Reducing power loss and operational costs",
      "Smooth power delivery: Ideal for applications like Electrostatic Precipitators (ESPs)",
      "Advanced design: Incorporating the latest innovations for durability and stability",
    ],
  },
  {
    q: "How do I choose the right IGBT module for my application?",
    a: "Choosing the right IGBT module depends on factors like:",
     bullets: [
      "Voltage and current ratings: Matching the power requirements of your system",
      "Switching frequency: Higher frequencies for motor drives and inverters",
      "Thermal performance: Ensuring efficient heat dissipation",
      "Application type: EVs, industrial control, power conversion, or renewable energy Consulting with experts or referring to the product specifications can help make the best choice.",
    ],
  },
];

const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700;800&display=swap');

  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
  .pcs-wrap { font-family: 'Poppins', sans-serif; color: #202020; background: #fff; }

  /* ══════════════════════════════════════════
     1. BREADCRUMB
  ══════════════════════════════════════════ */
  .pcs-breadcrumb { padding: 60px 0 0 0; }
  .pcs-breadcrumb-inner {
    max-width: 1600px;
    margin: 0 auto;
    padding: 0 102px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;
  }
  .pcs-bc-item {
    font-size: 16px;
    font-weight: 500;
    color: #202020;
    text-decoration: none;
    transition: color 0.15s;
  }
  .pcs-bc-item:hover { color: #EB2019; }
  .pcs-bc-item.pcs-active { color: #202020; }
  .pcs-bc-sep {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    margin: 0 8px;
    flex-shrink: 0;
  }

  /* ══════════════════════════════════════════
     SHARED INNER
  ══════════════════════════════════════════ */
  .pcs-inner {
    max-width: 1600px;
    margin: 0 auto;
    padding: 0 102px;
  }

  /* ══════════════════════════════════════════
     2. INTRO — image left + title + paras right
  ══════════════════════════════════════════ */
  .pcs-intro {
    padding: 60px 0 120px 0;
  }
  .pcs-intro-grid {
    display: flex;
    gap: 75px;
    align-items: center;
  }
  .pcs-intro-img-wrap {
    flex: 0 0 400px;
    border-radius: 10px;
    overflow: hidden;
  }
  .pcs-intro-img {
    width: 100%;
    height: 550px;
    object-fit: cover;
    display: block;
  }
  .pcs-intro-right { flex: 1; }
  .pcs-intro-title {
    font-size: 32px;
    font-weight: 600;
    color: #202020;
    line-height: 120%;
    margin-bottom: 14px;
  }
  .pcs-para {
    font-size: 16px;
    font-weight: 400;
    color: #202020;
    line-height: 160%;
  }
  .pcs-para + .pcs-para { margin-top: 14px; }
  /* Inline red bold text inside paragraphs */
  .pcs-para strong {
    font-weight: 600;
    color: #EB2019;
  }

  /* ══════════════════════════════════════════
     SHARED DIVIDER
  ══════════════════════════════════════════ */
  .pcs-divider {
    max-width: 1600px;
    margin: 0 auto;
    padding: 0 102px;
  }
  .pcs-divider hr {
    border: none;
    border-top: 1px solid #D4D4D4;
  }

  /* ══════════════════════════════════════════
     3. ADVANTAGES & APPLICATIONS
  ══════════════════════════════════════════ */
  .pcs-adv-section {
    padding: 0px 0 60px 0;
  }
  .pcs-section-red-title {
    font-size: 32px;
    font-weight: 600;
    color: #EB2019;
    text-align: center;
    margin-bottom: 0px;
  }
  .pcs-section-red-title1 {
    font-size: 32px;
    font-weight: 600;
    color: #EB2019;
    text-align: center;
    margin-bottom: 60px;
  }
  .pcs-sub-heading {
    font-size: 32px;
    font-weight: 600;
    color: #202020;
    text-align: center;
    margin-bottom: 34px;
    padding-top: 60px;
  }

  /* Icon cards grid */
  .pcs-icon-row {
    display: flex;
    justify-content: center;
    gap: 31px;
    margin-bottom: 60px;
  }
  .pcs-icon-row:last-child {
    display: flex;
    justify-content: center;
    gap: 31px;
    margin-bottom: 0px;
  }
  .pcs-icon-card {
    flex: 0 0 445px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 24px;
    text-align: center;
  }
  .pcs-icon-circle {
    width: 72px;
    height: 72px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }
  .pcs-icon-circle svg {
    width: 84px;
    height: 84px;
    filter: brightness(0) invert(1);
    display: block;
  }
  .pcs-icon-text {
    font-size: 20px;
    font-weight: 400;
    color: #202020;
    line-height: 160%;
  }

  /* ══════════════════════════════════════════
     4. END APPLICATIONS
  ══════════════════════════════════════════ */
  .pcs-app-section {
    padding: 0 0 80px 0;
  }
  .pcs-contact-para1 {
    font-size: 20px;
    font-weight: 500;
    color: #202020;
    text-align: center;
    line-height: 160%;
    margin-bottom: 0px;
  }
  .pcs-contact-para {
    font-size: 20px;
    font-weight: 500;
    color: #202020;
    text-align: center;
    line-height: 160%;
  }
  .pcs-contact-para a {
    color: #EB2019;
    text-decoration: none;
  }
  .pcs-contact-para a:hover { text-decoration: underline; }

  /* ══════════════════════════════════════════
     5. PRODUCT SPECIFICATIONS TABLE
  ══════════════════════════════════════════ */
  .pcs-spec-section {
    padding: 80px 0 0px 0;
  }
  .pcs-spec-table-wrap {
    border: 1px solid #D9D9D9;
    border-radius: 0;
    overflow: hidden;
    max-width: 1158px;
    margin: 0 auto;
  }
  .pcs-spec-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 16px;
    color: #202020;
  }
  .pcs-spec-table thead tr { background: #F6F6F6; }
  .pcs-spec-table thead th {
    padding: 30px 24px;
    font-weight: 600;
    text-align: center;
    line-height: 120%;
    border-bottom: 1px solid #B8B8B8;
    border-right: 1px solid #B8B8B8;
  }
  .pcs-spec-table thead th:last-child { border-right: none; }
  .pcs-spec-table tbody tr { border-bottom: 1px solid #D9D9D9; }
  .pcs-spec-table tbody tr:last-child { border-bottom: none; }
  .pcs-spec-table tbody tr:nth-child(even) { background: #F6F6F6; }
  .pcs-spec-table tbody td {
    padding: 30px 24px;
    text-align: center;
    border-right: 1px solid #B8B8B8;
    vertical-align: middle;
    font-weight: 400;
    line-height: 120%;
  }
  .pcs-spec-table tbody td:last-child { border-right: none; }
  .pcs-spec-hmi-img {
    width: 90px;
    height: 60px;
    object-fit: contain;
    display: block;
    margin: 0 auto;
  }

  /* ══════════════════════════════════════════
     6. FAQ SECTION
  ══════════════════════════════════════════ */
  .pcs-faq-section {
    padding: 120px 0 120px 0;
  }
  .pcs-faq-grid {
    display: flex;
    gap: 154px;
    align-items: flex-start;
  }
  .pcs-faq-title {
    flex: 0 0 391px;
    font-size: 42px;
    font-weight: 600;
    color: #202020;
    line-height: 140%;
  }
  .pcs-faq-list {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 20px;
  }

  /* FAQ item wrapper */
  .pcs-faq-item {
    border-radius: 5px;
    overflow: hidden;
  }
  .pcs-faq-item-closed { background: #F6F6F6; }
  .pcs-faq-item-open   { background: #F6F6F6; }

  /* Question button */
  .pcs-faq-question {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    padding: 24px 34px 20px 30px;
    background: transparent;
    border: none;
    cursor: pointer;
    text-align: left;
  }
  .pcs-faq-q-text-open {
    font-size: 16px;
    font-weight: 500;
    color: #EB2019;
    line-height: 120%;
    flex: 1;
  }
  .pcs-faq-q-text-closed {
    font-size: 16px;
    font-weight: 400;
    color: #202020;
    line-height: 150%;
    flex: 1;
  }
  .pcs-faq-chevron {
    flex-shrink: 0;
    width: 20px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  /* ── Smooth accordion answer panel ── */
  .pcs-faq-body {
    overflow: hidden;
    transition: max-height 0.4s ease, opacity 0.4s ease;
    opacity: 0;
    max-height: 0;
  }
  .pcs-faq-body.pcs-faq-body-open { opacity: 1; }
  .pcs-faq-answer {
    padding: 0 48px 12px 30px;
    font-size: 14px;
    font-weight: 400;
    color: #202020;
    line-height: 160%;
  }
  /* Bullet list inside FAQ answer */
  .pcs-faq-answer-bullets {
    padding: 0 48px 24px 46px;
    font-size: 14px;
    font-weight: 400;
    color: #202020;
    line-height: 160%;
    list-style: disc;
  }
  .pcs-faq-answer-bullets li { margin-bottom: 4px; }

  /* ══════════════════════════════════════════
     RESPONSIVE — TABLET 768px
  ══════════════════════════════════════════ */
  @media (max-width: 768px) {
    .pcs-breadcrumb        { padding: 28px 0 0 0; }
    .pcs-breadcrumb-inner  { padding: 0 32px; }
    .pcs-inner             { padding: 0 32px; }
    .pcs-divider           { padding: 0 32px; }

    .pcs-intro             { padding: 40px 0 40px 0; }
    .pcs-intro-grid        { flex-direction: column; gap: 24px; }
    .pcs-icon-circle img   { width: 60px; height: 60px; }
    .pcs-icon-circle       { width: 54px; height: 54px; }
    .pcs-icon-text         { font-size: 16px; }
    .pcs-intro-img-wrap    { flex: none; width: 100%; }
    .pcs-intro-img         { height: 280px; }
    .pcs-intro-title       { font-size: 22px; }
    .pcs-para              { font-size: 14px; }

    .pcs-adv-section       { padding: 0px 0 40px 0; }
    .pcs-section-red-title { font-size: 22px; margin-bottom: 0px; }
    .pcs-sub-heading       { font-size: 20px; margin-bottom: 30px; padding-top: 30px; }
    .pcs-icon-row          { flex-wrap: wrap; gap: 24px; margin-bottom: 30px; }
    .pcs-app-section       { padding: 0 0 40px 0; }
    .pcs-icon-card         { flex: 0 0 210px; }
    .pcs-contact-para      { font-size: 16px; text-align: left; }
    .pcs-contact-para1     { font-size: 16px; text-align: left; }
    .pcs-section-red-title1 { font-size: 22px; margin-bottom: 24px; }

    .pcs-spec-section      { padding: 40px 0 40px 0; }
    .pcs-spec-table        { font-size: 14px; }
    .pcs-spec-table thead th { padding: 14px 12px; }
    .pcs-spec-table tbody td { padding: 14px 12px; }

    .pcs-faq-section       { padding: 0px 0 40px 0; }
    .pcs-faq-grid          { flex-direction: column; gap: 24px; }
    .pcs-faq-title         { flex: none; font-size: 22px; margin: 0 auto; }
    .pcs-faq-q-text-open   { font-size: 14px; }
    .pcs-faq-list          { gap: 16px; }
    .pcs-faq-question      { padding: 20px 34px 16px 30px; }
    .pcs-faq-answer        { padding: 0 44px 12px 30px; }
    .pcs-faq-answer-bullets { padding: 0 44px 24px 46px; }
    .pcs-faq-q-text-closed { font-size: 14px; }
  }

  /* ══════════════════════════════════════════
     RESPONSIVE — MOBILE 480px
  ══════════════════════════════════════════ */
  @media (max-width: 480px) {
    .pcs-breadcrumb        { padding: 30px 0 0 0; }
    .pcs-breadcrumb-inner  { padding: 0 16px; gap: 14px; }
    .pcs-bc-item           { font-size: 14px; }
    .pcs-bc-sep            { width: 18px; height: 18px; margin: 0 4px; }
    .pcs-inner             { padding: 0 16px; }
    .pcs-divider           { padding: 0 16px; }

    .pcs-intro             { padding: 30px 0 0px 0; }
    .pcs-intro-grid        { gap: 30px; }
    .pcs-intro-img         { height: 432px; }
    .pcs-intro-title       { font-size: 20px; margin-bottom: 20px; }

    .pcs-adv-section       { padding: 60px 0 60px 0; }
    .pcs-section-red-title { font-size: 20px; margin-bottom: 0px; text-align: left; }
    .pcs-sub-heading       { font-size: 20px; margin-bottom: 30px; }
    .pcs-icon-row          { flex-direction: column; align-items: start; gap: 30px; margin-bottom: 30px; }
    .pcs-icon-card         { flex: none; width: 100%; max-width: 100%; text-align: left; align-items: flex-start; }
    .pcs-icon-circle img   { width: 60px; height: 60px; }
    .pcs-icon-text         { font-size: 16px; }

    .pcs-app-section       { padding: 0 0 60px 0; }
    .pcs-contact-para      { font-size: 16px; margin-top: 30px; }
    .pcs-contact-para1     { font-size: 16px; margin-bottom: 30px; }
    .pcs-section-red-title1 { font-size: 20px; margin-bottom: 30px; }

    .pcs-spec-section      { padding: 40px 0 0px 0; }
    .pcs-spec-table-wrap   { overflow-x: auto; }
    .pcs-spec-table        { min-width: auto; }
    .pcs-spec-table thead th { padding: 30px 8px; font-size: 16px; }
    .pcs-spec-table tbody td { padding: 30px 8px; font-size: 14px; }

    .pcs-faq-section       { padding: 60px 0 60px 0; }
    .pcs-faq-grid          { gap: 30px; }
    .pcs-faq-title         { font-size: 20px; }
    .pcs-faq-question      { padding: 24px 16px 20px 16px; }
    .pcs-faq-answer        { padding: 0 16px 12px 16px; font-size: 13px; }
    .pcs-faq-answer-bullets { padding: 0 16px 16px 30px; font-size: 13px; }
  }
`;

/* Chevron SVGs */
const ChevronUp = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path d="M5 12.5L10 7.5L15 12.5" stroke="#202020" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);
const ChevronDown = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path d="M5 7.5L10 12.5L15 7.5" stroke="#202020" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

/* ── Smooth FAQ accordion item ── */
const FaqItem = ({ q, a, bullets, isOpen, onToggle }) => {
  const bodyRef = useRef(null);

  useEffect(() => {
    const el = bodyRef.current;
    if (!el) return;
    if (isOpen) {
      el.style.maxHeight = el.scrollHeight + "px";
    } else {
      el.style.maxHeight = el.scrollHeight + "px";
      el.getBoundingClientRect();
      el.style.maxHeight = "0px";
    }
  }, [isOpen]);

  return (
    <div className={`pcs-faq-item ${isOpen ? "pcs-faq-item-open" : "pcs-faq-item-closed"}`}>
      <button className="pcs-faq-question" onClick={onToggle}>
        <span className={isOpen ? "pcs-faq-q-text-open" : "pcs-faq-q-text-closed"}>{q}</span>
        <span className="pcs-faq-chevron">{isOpen ? <ChevronUp /> : <ChevronDown />}</span>
      </button>
      <div
        ref={bodyRef}
        className={`pcs-faq-body${isOpen ? " pcs-faq-body-open" : ""}`}
      >
        <p className="pcs-faq-answer">{a}</p>
        {bullets && bullets.length > 0 && (
          <ul className="pcs-faq-answer-bullets">
            {bullets.map((b, i) => <li key={i}>{b}</li>)}
          </ul>
        )}
      </div>
    </div>
  );
};

export default function PreiconS() {
  const [openIndex, setOpenIndex] = useState(0);
  const handleToggle = (i) => {
    setOpenIndex(prev => (prev === i ? null : i));
  };

  return (
    <div className="pcs-wrap">
      <style>{CSS}</style>

      {/* ══ 1. BREADCRUMB ══ */}
      <nav className="pcs-breadcrumb" aria-label="Breadcrumb">
        <div className="pcs-breadcrumb-inner">
          <a href="/" className="pcs-bc-item">Home</a>
          <span className="pcs-bc-sep"><img src={BcSepIcon} alt="" /></span>
          <a href="#" className="pcs-bc-item">Business</a>
          <span className="pcs-bc-sep"><img src={BcSepIcon} alt="" /></span>
          <a href="/products" className="pcs-bc-item">Clean Air</a>
          <span className="pcs-bc-sep"><img src={BcSepIcon} alt="" /></span>
          <span className="pcs-bc-item pcs-active">IGBT Modules</span>
        </div>
      </nav>

      {/* ══ 2. INTRO ══ */}
      <section className="pcs-intro">
        <div className="pcs-inner">
          <div className="pcs-intro-grid">

            {/* Left — product image */}
            <div className="pcs-intro-img-wrap">
              <img className="pcs-intro-img" src={ProductImg} alt="Precicon S" />
            </div>

            {/* Right — title + 4 paragraphs with inline red bold */}
            <div className="pcs-intro-right">
              <h1 className="pcs-intro-title">
                Precicon S – High-Frequency Power Supply With IGBT Module For Superior ESP Performance
              </h1>
              <p className="pcs-para">
                Ador Powertron's Precicon S is an advanced <strong>IGBT-based power controller</strong> featuring a robust <strong>IGBT module</strong> for Electrostatic Precipitators (ESPs), utilizing high-frequency power switching to deliver better performance than conventional thyristor-based systems. Its 3-phase input ensures stable and efficient power delivery, making it ideal for demanding industries like cement, steel, power, paper &amp; pulp, and chemicals.
              </p>
              <p className="pcs-para">
                What makes Precicon S superior is its ability to generate smoother power output with reduced ripples, ensuring more consistent and effective dust separation. Unlike thyristor-based controllers, which switch at lower frequencies, the <strong>high-speed IGBT module</strong> in Precicon S enables faster voltage regulation and more precise control, even under fluctuating dust loads. This reduces the electrical stress on ESP components, extending equipment life and lowering maintenance costs. Additionally, it minimizes energy losses, making operations more efficient and sustainable.
              </p>
              <p className="pcs-para">
                With CAN Bus communication for seamless integration and DCS connectivity through the DCSIM Gateway for remote monitoring, Precicon S supports proactive maintenance to minimize downtime. In-built rapping control further enhances ESP efficiency by optimizing cleaning cycles, ensuring continuous dust collection and compliance with environmental standards.
              </p>
              <p className="pcs-para">
                Choose Precicon S and its advanced <strong>IGBT module technology</strong> for improved performance, reliability, and operational efficiency. Contact us today to learn how it can elevate your ESP systems.
              </p>
            </div>

          </div>
        </div>
      </section>

      {/* ══ 3. ADVANTAGES ══ */}
      <section className="pcs-adv-section">
        <div className="pcs-inner">
          <h2 className="pcs-section-red-title">Precicon S: Advantages &amp; Applications</h2>
          <h3 className="pcs-sub-heading">Advantages</h3>

          {/* Row 1 — 3 cards */}
          <div className="pcs-icon-row">
            {ADVANTAGES.slice(0, 3).map((item, i) => (
              <div key={i} className="pcs-icon-card">
                <div className="pcs-icon-circle">
                  <img src={item.icon} alt="" />
                </div>
                <p className="pcs-icon-text">{item.text}</p>
              </div>
            ))}
          </div>

          {/* Row 2 — 3 cards */}
          <div className="pcs-icon-row">
            {ADVANTAGES.slice(3, 6).map((item, i) => (
              <div key={i} className="pcs-icon-card">
                <div className="pcs-icon-circle">
                  <img src={item.icon} alt="" />
                </div>
                <p className="pcs-icon-text">{item.text}</p>
              </div>
            ))}
          </div>

          {/* Row 3 — 1 card centered */}
          <div className="pcs-icon-row">
            {ADVANTAGES.slice(6, 7).map((item, i) => (
              <div key={i} className="pcs-icon-card">
                <div className="pcs-icon-circle">
                  <img src={item.icon} alt="" />
                </div>
                <p className="pcs-icon-text">{item.text}</p>
              </div>
            ))}
          </div>

        </div>
      </section>

      {/* ══ DIVIDER ══ */}
      <div className="pcs-divider"><hr /></div>

      {/* ══ 4. END APPLICATIONS ══ */}
      <section className="pcs-app-section">
        <div className="pcs-inner">
          <h3 className="pcs-sub-heading">End Applications</h3>

          {/* 2 cards centered */}
          <div className="pcs-icon-row">
            {END_APPLICATIONS.map((item, i) => (
              <div key={i} className="pcs-icon-card">
                <div className="pcs-icon-circle">
                  <img src={item.icon} alt="" />
                </div>
                <p className="pcs-icon-text">{item.text}</p>
              </div>
            ))}
          </div>

          {/* Single plain paragraph — no red link */}
          <p className="pcs-contact-para1">
            Precicon S delivers reliable, efficient, and sustainable ESP performance tailored to industrial needs.
          </p>
        </div>
      </section>

      {/* ══ DIVIDER ══ */}
      <div className="pcs-divider"><hr /></div>

      {/* ══ 5. PRODUCT SPECIFICATIONS ══ */}
      <section className="pcs-spec-section">
        <div className="pcs-inner">
          <h2 className="pcs-section-red-title1">Product Specifications</h2>
          <div className="pcs-spec-table-wrap">
            <table className="pcs-spec-table">
              <thead>
                <tr>
                  <th>Category</th>
                  <th>Conventional</th>
                </tr>
              </thead>
              <tbody>
                {SPECS.map((row, i) => (
                  <tr key={i}>
                    <td>{row.label}</td>
                    <td>
                      {row.isImage
                        ? <img className="pcs-spec-hmi-img" src={row.value} alt="HMI" />
                        : row.value
                      }
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </section>

      {/* ══ 6. FAQ ══ */}
      <section className="pcs-faq-section">
        <div className="pcs-inner">
          <div className="pcs-faq-grid">

            {/* Left — title */}
            <h2 className="pcs-faq-title">Frequently Asked Questions (FAQs)</h2>

            {/* Right — accordion */}
            <div className="pcs-faq-list">
              {FAQS.map((faq, i) => (
                <FaqItem
                  key={i}
                  q={faq.q}
                  a={faq.a}
                  bullets={faq.bullets}
                  isOpen={openIndex === i}
                  onToggle={() => handleToggle(i)}
                />
              ))}
            </div>

          </div>
        </div>
      </section>

    </div>
  );
}